import React, { useState, useLayoutEffect, useRef } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
// import Moment from "react-moment";
import { GuestForm } from "./GuestForm";
import { fetchGuilds } from "../../utils/api/helpers/guild";
import { createRsvp } from "../../utils/api/helpers/rsvp";

import {
	loadCaptchaEnginge,
	LoadCanvasTemplateNoReload,
	validateCaptcha,
} from "react-simple-captcha";

const EventRSVPForm = ({
	event_slug,
	allowGuests,
	title,
	start_date,
	start_time,
	guestThreshold,
}) => {
	const [guild_list, setGuildList] = useState([]),
		[formIsValid, setFormIsValid] = useState(false),
		[captchaTried, setCaptchaTried] = useState(false),
		[captchaValid, setCaptchaValid] = useState(false),
		[formSubmitClicked, setFormSubmitClicked] = useState(false),
		[formSubmitted, setFormSubmitted] = useState(false);

	const [name, setName] = useState(""),
		[email, setEmail] = useState(""),
		[guild_affiliation, setGuildAffiliation] = useState(null),
		[venue_id, setVenueId] = useState(null),
		[guestList, setGuestList] = useState([]),
		[rsvp_status, setRsvpStatus] = useState(null);

	const captchaRef = useRef();

	useLayoutEffect(() => {
		let subscribed = true;
		if (subscribed && event_slug) {
			setFormIsValid(false);
			setFormSubmitClicked(false);
			setFormSubmitted(false);
			setName("");
			setEmail("");
			setGuildAffiliation("");
			setVenueId("");
			setGuestList([]);
			setRsvpStatus(null);
			setCaptchaTried(false);
			setCaptchaValid(false);

			loadCaptchaEnginge(6);
		}
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [event_slug]);

	useLayoutEffect(() => {
		let subscribed = true;
		if (subscribed)
			fetchGuilds().then((result) => {
				// console.log(result);
				if (!result.error) setGuildList(result.data);
			});
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const updateGuestList = (idx, guest, remove) => {
		let l = guestList.slice();
		if (remove) {
			l = l.filter((el) => {
				return el.name !== guest.name;
			});
			setGuestList(l);
		} else {
			if (idx < 0) {
				l.push(guest);
			} else {
				l[idx] = guest;
			}
			setGuestList(l);
		}
	};

	const person = () => {
		return {
			name: name,
			email: email,
			guild_id: guild_affiliation,
			venue_id: venue_id,
			guests: guestList,
		};
	};

	// const reset = () => {
	// 	setName("");
	// 	setEmail("");
	// 	setGuildAffiliation(null);
	// 	setGuestList([]);
	// };

	const submitRsvp = () => {
		createRsvp(event_slug, person()).then((result) => {
			setRsvpStatus(result);
			setFormSubmitted(true);
		});
	};

	return (
		<div className="rsvpform__container w-100 d-flex flex-column justify-content-start">
			{!formSubmitClicked ? (
				<Form>
					<div className={"row"}>
						<Col lg={12}>
							<Form.Group controlId="signup_name">
								<Form.Control
									value={name}
									required
									onChange={(e) => setName(e.target.value)}
									placeholder="Name"
									className={"nf-sans-cond mb-2"}
								/>
							</Form.Group>
							{formSubmitClicked &&
							!formIsValid &&
							name === "" ? (
								<div className="validation__message">
									Please enter a Name
								</div>
							) : (
								""
							)}
						</Col>
					</div>
					<div className={"row"}>
						<div className={"col-12 col-md-6 mb-2 pe-md-0"}>
							<Form.Group controlId="signup_email">
								<Form.Control
									type="email"
									required
									value={email}
									placeholder="Email"
									className={"nf-sans-cond"}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</Form.Group>
							{formSubmitClicked &&
							!formIsValid &&
							(email === "" || email.indexOf("@") < 0) ? (
								<div className="validation__message">
									Please enter a valid email address
								</div>
							) : (
								""
							)}
						</div>
						<div className={"col-12 col-md-6 ps-md-2 mb-2"}>
							<Form.Group controlId="signup_event">
								<Form.Control
									as="select"
									required
									value={guild_affiliation || ""}
									onChange={(e) =>
										setGuildAffiliation(e.target.value)
									}
								>
									<option value={null}>
										Select Guild Affiliation
									</option>

									{guild_list.map((ga, i) => {
										return (
											<option key={i} value={ga.guild_id}>
												{ga.name}
											</option>
										);
									})}
								</Form.Control>
							</Form.Group>
							{formSubmitClicked &&
							!formIsValid &&
							(guild_affiliation <= 0 ||
								guild_affiliation ===
									"Select Guild Affiliation") ? (
								<div className="validation__message">
									Please select a Guild Affiliation
								</div>
							) : (
								""
							)}
						</div>

						{allowGuests && guestThreshold > 0 ? (
							<div className="py-2 w-100">
								<div className="row">
									<div className="col-12 d-flex align-items-center">
										<div
											className="mb-1 py-2"
											style={{ fontSize: "1.5rem" }}
										>
											GUEST(S)
										</div>

										{guestList.length < guestThreshold ? (
											<Button
												className="ms-auto rsvp-button"
												onClick={(e) =>
													updateGuestList(-1, {
														name: "",
													})
												}
											>
												<span className="label-small">
													+ Add Guest
												</span>
											</Button>
										) : (
											<span className="ms-auto text-uppercase">
												{guestThreshold} guest
												{guestThreshold > 1
													? "s"
													: ""}{" "}
												{guestThreshold > 1
													? "are"
													: "is"}{" "}
												allowed for this event.
											</span>
										)}
									</div>
								</div>
								{guestList
									? guestList.map((gl, i) => (
											<GuestForm
												key={i}
												idx={i}
												updateGuest={updateGuestList}
												formSubmitClicked={
													formSubmitClicked
												}
												formIsValid={formIsValid}
											/>
										))
									: ""}
							</div>
						) : (
							""
						)}

						<div className="mb-0 d-flex flex-column flex-md-row ">
							<div className="d-flex align-items-stretch rsvp-captcha-container pe-0 pe-md-2">
								<LoadCanvasTemplateNoReload />
								<Form.Control
									ref={captchaRef}
									className="ms-2"
									style={{
										opacity: 1,
										borderBottom: "1px solid #666",
									}}
									placeholder="Enter Captcha Code"
								/>
							</div>

							<div className="flex-grow-1 mt-3 mt-md-0 d-flex align-items-stretch justify-content-center">
								<Button
									className="rsvp-button submit-button w-100"
									onClick={(e) => {
										if (
											person().name !== "" &&
											person().email !== "" &&
											person().email.indexOf("@") > 0
										) {
											if (person().guests.length > 0) {
												const hasBlanks =
													person().guests.filter(
														(o) => {
															return (
																o.name === ""
															);
														},
													);

												if (hasBlanks.length > 0) {
													setFormIsValid(false);
												} else {
													if (
														validateCaptcha(
															captchaRef.current
																.value,
														)
													) {
														setCaptchaValid(true);
														setFormIsValid(true);
														setFormSubmitClicked(
															true,
														);
														submitRsvp();
														setFormSubmitted(true);
													} else {
														setCaptchaTried(true);
														setCaptchaValid(false);
													}
												}
											} else {
												if (
													validateCaptcha(
														captchaRef.current
															.value,
													)
												) {
													setCaptchaValid(true);
													setFormIsValid(true);
													setFormSubmitClicked(true);
													submitRsvp();
													setFormSubmitted(true);
												} else {
													setCaptchaTried(true);
													setCaptchaValid(false);
												}
											}
										} else {
											setFormIsValid(false);
										}
									}}
								>
									{"Submit RSVP"}
								</Button>
							</div>
						</div>
					</div>
					{captchaTried && !captchaValid ? (
						<Row
							className="justify-content-center font-weight-bold pt-4 text-uppercase"
							style={{ fontSize: "1.5rem" }}
						>
							Captcha Code does not match, please try again
						</Row>
					) : null}
				</Form>
			) : (
				<div
					className={"text-uppercase"}
					style={{ fontSize: "1.5rem" }}
				>
					{!formSubmitted ? (
						<div className="text-center my-5">Sending RSVP...</div>
					) : (
						<>
							{(() => {
								switch (rsvp_status) {
									case "DUPE_EMAIL":
										return (
											<div className="dupeuser text-center my-5">
												This name has already been
												submitted for this event.
											</div>
										);
									case "CONFIRM":
										return (
											<div className="confirm text-center my-5">
												Thank you for submitting your
												RSVP to{" "}
												<span className="font-weight-bold">
													{title}
												</span>
												!<br />
												<br />
												You will receive a reply via
												email shortly.
											</div>
										);
									case "DENY":
										return (
											<div className="deny text-center my-5">
												Capacity for{" "}
												<span className="font-weight-bold">
													{title}
												</span>{" "}
												has been reached.
											</div>
										);
									case "GUEST_EXCEEDED":
										return (
											<div className="guestexceed text-center my-5">
												Your guests exceed the number of
												allowed guests for{" "}
												<span className="font-weight-bold">
													{title}
												</span>
												. <br />
												<br />
												Please refresh this page and
												re-submit with fewer guests.
											</div>
										);
									case "REQUEST":
										return (
											<div className="request text-center my-5">
												Thank you for submitting your
												RSVP to{" "}
												<span className="font-weight-bold">
													{title}
												</span>
												! <br />
												<br />
												You will receive a reply via
												email shortly.
											</div>
										);
									default:
										return (
											<div className="default text-center my-5">
												Thank you for submitting your
												RSVP to{" "}
												<span className="font-weight-bold">
													{title}
												</span>
												!<br />
												<br />
												You will receive a reply via
												email shortly.
											</div>
										);
								}
							})()}
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default EventRSVPForm;
